import Phaser from 'phaser';
import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import { LevelConfig } from '../components/LevelConfig';
import translate from '../components/LanguageManager';

export default class LevelSelectorInfo extends BaseScene {
    private levelId = 0;
    private level?: LevelConfig;
    private levelScore: integer = 0;
    private description = '';
    private image?: string;
    private container: any;

    constructor() {
        super({key: 'LevelSelectorInfo'});
    }

    public init(data: { levelId: number }) {
        super.init(data);
        this.levelId = data.levelId;

        const levels: any[] = this.cache.json.get('levels');
        this.level = levels.find(level => level.id === this.levelId);

        if (!this.level) {
            throw new Error(`Level with id ${this.levelId} not found`);
        }

        this.description = translate.key(`level_description_${this.levelId}`);
        this.image = this.level.image;
        this.levelScore = this.getBootloaderScene().AppData.getScoreLevel(this.levelId);
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_main_big_01');

        const title = this.add.text(0, -246, `${translate.key('Level')} ` + this.levelId)
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 56,
                color: '#fff'
            })
            .setStroke('#212121', 6);

        const description = this.add.text(0, -20, this.description)
            .setOrigin(0.5)
            .setWordWrapWidth(254)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 22,
                color: '#3d3d3d',
                align: 'center'
            });

        const maxScore = this.add.text(0, 115, `${translate.key('game_winned_text_2')}: ` + this.levelScore)
            .setOrigin(0.5)
            .setWordWrapWidth(254)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 16,
                color: '#777',
                align: 'center'
            });

        const replayButton = new ButtonSprite(this, -95, 215, 'button_back', 2, () => this.backToLevelSelector());

        const nextButton = new ButtonSprite(this, 95, 215, 'button_next', 2,() => this.startGame());
 
        this.container = this.add.container(this.width / 2, -300).add([panel, title, description, maxScore, replayButton, nextButton]);

        if(this.image && this.textures.exists(this.image)) {
            const image = this.add.image(0, -100, this.image).setScale(1.4);
            this.container.add(image);
            const titleInContainer = (this.container.getAt(2) as Phaser.GameObjects.Text);
            titleInContainer.setY(30);
        }

        // Tween
        this.tweens.add({
            y: 460,
            targets: this.container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

    }

    startGame() {
        this.getBootloaderScene().launchScene('GameLevel', this.level);
    }

    backToLevelSelector() {
        this.getBootloaderScene().launchScene('LevelSelector');
    }
}
